import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=3a6b2238&lang=pug&"
import script from "./CourseInfo.vue?vue&type=script&lang=js&"
export * from "./CourseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports